export const initFmbMachineData = (): void => {
  const downloadButtons = document.querySelectorAll<HTMLButtonElement>(
    "[data-fmb-pdf-download]",
  );

  if (downloadButtons.length === 0) {
    return;
  }

  downloadButtons.forEach((button) => {
    button.addEventListener("click", async () => {
      const postId = button.dataset.postId;
      const feedbackEl = button.parentElement?.querySelector<HTMLElement>(
        ".fmb-machine-data__pdf-feedback",
      );
      const btnSpan = button.querySelector("span");
      const originalText = btnSpan?.textContent || "";

      if (!postId) return;

      // Butonu bekleme durumuna al
      button.disabled = true;
      if (btnSpan) btnSpan.textContent = "İndiriliyor...";
      if (feedbackEl) {
        feedbackEl.style.display = "none";
        feedbackEl.textContent = "";
      }

      try {
        const rootUrl = (window as any).commonVariables?.rootUrl || "/wp-json";
        const customBase =
          (window as any).commonVariables?.customRestApiBase ||
          `${rootUrl}/corporate-app/v1`;

        const response = await fetch(
          `${customBase}/products/${postId}/download-pdf`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        const data = await response.json();

        if (response.ok && data.download_url) {
          // İndirmeyi başlat
          const link = document.createElement("a");
          link.href = data.download_url;
          link.target = "_blank";
          link.download = "";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          // 429 Rate Limit veya 404 gibi hatalar
          if (feedbackEl) {
            feedbackEl.style.display = "block";
            feedbackEl.textContent =
              data.message || "İndirme sırasında bir hata oluştu.";
          }
        }
      } catch (err: any) {
        if (feedbackEl) {
          feedbackEl.style.display = "block";
          feedbackEl.textContent =
            "Sunucuya bağlanılamadı. Lütfen tekrar deneyiniz.";
        }
      } finally {
        button.disabled = false;
        if (btnSpan) btnSpan.textContent = originalText;
      }
    });
  });
};
